import { lazy } from 'react';

export const Mollogotchi = lazy(
    () => import(/* webpackChunkName: "interactive_mollogotchi" */ './mollogotchi'),
);
export const Bingo2025 = lazy(
    () => import(/* webpackChunkName: "interactive_bingo2025" */ './bingo-2025'),
);
export const QuizSaqGenz = lazy(
    () => import(/* webpackChunkName: "interactive_quiz-saq-genz" */ './quiz-theme'),
);
export const QuizTheme = lazy(
    () => import(/* webpackChunkName: "interactive_quiz-theme" */ './quiz-theme'),
);
export const RecoursCollectifs = lazy(
    () => import(/* webpackChunkName: "interactive_recours-collectifs" */ './recours-collectifs'),
);
export const AiCanvas = lazy(
    () => import(/* webpackChunkName: "interactive_ai-canvas" */ './ai-canvas'),
);
export const AiParle = lazy(
    () => import(/* webpackChunkName: "interactive_ai-parle" */ './ai-parle'),
);
export const PieChart = lazy(
    () => import(/* webpackChunkName: "interactive_pie-chart" */ './chart/PieChart'),
);
export const BarChart = lazy(
    () => import(/* webpackChunkName: "interactive_bar-chart" */ './chart/BarChart'),
);
